import { FC } from 'react'
import { FlexboxGrid } from 'rsuite'
import CloseIcon from '@rsuite/icons/Close'
import { useRouter } from 'next/router'
import omit from 'lodash/omit'
import { useClearRefinements } from 'react-instantsearch'

import { FilterItem } from '../../utils/types/misc'
import useUrls from '../../services/useUrls'

import styles from '../../styles/FilterTags.module.less'

interface FilterTagProps {
  filter: FilterItem
  filterKey: string
  removeAppliedFilterItem: (filterKey: string, value: string | number) => void
  filterKeyToAttributeMap: Record<string, string>
}

const FilterTag: FC<FilterTagProps> = (props) => {
  const { filter, filterKey, filterKeyToAttributeMap, removeAppliedFilterItem } = props

  const { pushT } = useUrls()
  const { query, asPath } = useRouter()
  const {
    refine: clear,
  } = useClearRefinements({
    includedAttributes: [filterKeyToAttributeMap[filterKey]],
  })

  const handleRemoveFilterTag = () => {
    clear()

    // Remove from local state
    removeAppliedFilterItem(filterKey, filter.value)

    // Remove from URL query params
    const currentQueries = { ...query }
    if (currentQueries[filterKey]) {
      // Handle multi-value filters (e.g., f_supid=1-7)
      const currentValue = currentQueries[filterKey] as string

      // Check if this is a multi-value filter
      if (currentValue.includes('-')) {
        // Split by "-" to get all values
        const values = currentValue.split('-')

        // Filter out the value we want to remove
        const newValues = values.filter((v) => v !== filter.value.toString())

        if (newValues.length > 0) {
          // If we still have values, update the query param
          currentQueries[filterKey] = newValues.join('-')
        } else {
          // If no values left, remove the query param
          delete currentQueries[filterKey]
        }
      } else {
        // Single value, just remove the param
        delete currentQueries[filterKey]
      }

      // Push the updated URL
      pushT({
        pathname: asPath.split('?')?.[0],
        query: omit(currentQueries, ['filters']),
      }, undefined, { shallow: true })
    }
  }

  return (
    <FlexboxGrid
      align="middle"
      key={filter.label}
      className={styles['filter-tag']}
    >
      <p className="margin-right-spacer">{filter.label}</p>
      <button
        onClick={handleRemoveFilterTag}
        type="button"
      >
        <CloseIcon
          width={12}
          height={12}
        />
      </button>
    </FlexboxGrid>
  )
}

export default FilterTag
